export { default } from './TermsAndConditions';
